import axios from 'axios';

async function postRequestIngredients(url, params, config) {
  try {
    const response = await axios.post(url, { requests: params }, config);
    return response;
  } catch (e) {
    console.log('error =>', e);
    return { error: e };
  }
}

async function postRequests(url, data, config) {
  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (e) {
    console.log('error =>', e);
    return { error: e };
  }
}

async function getRequest(url) {
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export { postRequestIngredients, postRequests, getRequest };
